export default __webpack_public_path__ + "static/media/svg-5.be861dcb.svg";